import ATabPane from './index.vue';

ATabPane.install = app => {
  app.component(ATabPane.name, ATabPane);
};

export default ATabPane;
